import MetricFlow from "@/icons/MetricFlow";
import SentimentNeutralIcon from '@mui/icons-material/SentimentNeutral';
import MetricLevel from "@/icons/MetricLevel";
import MetricTemperature from "@/icons/MetricTemperature";
import MetricPh from "@/icons/MetricPh";
import MetricVelocity from "@/icons/MetricVelocity";
import MetricTurbidity from "@/icons/MetricTurbidity";
import MetricBattery from "@/icons/MetricBattery";

const METRIC_ICONS: Record<string, React.ElementType> = {
  'FLOW': MetricFlow,
  'LEVEL': MetricLevel,
  'TEMPERATURE': MetricTemperature,
  'PH': MetricPh,
  'TURBIDITY_NTU': MetricTurbidity,
  'VELOCITY': MetricVelocity,
  'BATTERY_SOC': MetricBattery,
  // Agrega aquí más mapeos según tus datos
};

export const getMetricIcon = (metricName: string): React.ElementType => {
  const normalizedName = metricName?.toUpperCase() || '';

  return METRIC_ICONS[normalizedName] || SentimentNeutralIcon;
};